import { Text } from '$components'
import { CalendarIcon } from '$components'

export function NoAppointmentHistoryEmptyState() {
  return (
    <div className="w-full p-12 bg-neutral-50 rounded-3xl flex flex-col items-center justify-center text-center">
      <CalendarIcon className="size-12 text-indigo-500 mb-4" />

      <Text
        type="h3"
        className="mb-4 text-gray-900"
      >
        No appointment history
      </Text>

      <Text
        type="s"
        className="text-gray-600 max-w-sm"
      >
        This pet doesn&apos;t have any other appointments yet.
      </Text>
    </div>
  )
}
